'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _querychanges = require('./querychanges.html');

var _querychanges2 = _interopRequireDefault(_querychanges);

var _querychanges3 = require('./querychanges.controller');

var _querychanges4 = _interopRequireDefault(_querychanges3);

require('./querychanges.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var querychangesComponent = {
  restrict: 'E',
  bindings: {},
  template: _querychanges2.default,
  controller: _querychanges4.default,
  controllerAs: 'vm'
};

exports.default = querychangesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/querychanges/querychanges.component.js